export default __webpack_public_path__ + "question-mark-on-a-circular-black-background.png";